import Navbar from "components/Navbar"
import React from "react";
import Footer from "components/Footer";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import ProgramAll from "components/Program/ProgramAll";
import { useEffect } from "react";

function Program () {

    const isMobile = useSelector(state => state.windowSize.isMobile);
    
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <ProgramAll />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <ProgramAll />
            <Footer />
            </>
        )}
        </>
    )
}

export default Program